// extracted by mini-css-extract-plugin
export default {"mainContainer":"SharedLayout_mainContainer__NpTfh"};